import type { CSSProperties } from 'react';

import { pixelSizeHelperPortalUi } from '../../utils/pixelSizeHelperPortalUi';

export const portalWidgetContentStyle: CSSProperties = {
  padding: `${pixelSizeHelperPortalUi(24)}px ${pixelSizeHelperPortalUi(32)}px`,
};
